import { httpClient } from '@/services/http/httpClient'

export type CreateTaskRequest = {
  title: string
  description?: string
  projectId: string
  sequence: number
}

export async function createTask({
  title,
  description,
  projectId,
  sequence,
}: CreateTaskRequest) {
  await httpClient.post('/projects/project-tasks', {
    title,
    description,
    projectId,
    sequence,
  })
}
